import { useCallback } from "react";
import {
  UseErrorNotificationsResult,
  useErrorNotificationsState,
} from "./useErrorNotificationsState";
import {
  UseToastNotificationsResult,
  useToastNotificationsState,
  UseToastNotificationsStateOptions,
} from "./useToastNotificationsState";

export type UseNotificationsResult = UseToastNotificationsResult &
  UseErrorNotificationsResult & {
    clearAll: () => void;
  };

export const useNotificationsState = (
  options?: UseToastNotificationsStateOptions
): UseNotificationsResult => {
  const toastNotifications = useToastNotificationsState(options);
  const errorNotifications = useErrorNotificationsState();
  const { clearToasts } = toastNotifications;
  const { clearErrors } = errorNotifications;

  const clearAll = useCallback(() => {
    clearToasts();
    clearErrors();
  }, [clearErrors, clearToasts]);

  return {
    ...toastNotifications,
    ...errorNotifications,
    clearAll,
  };
};
